module.exports = __webpack_public_path__ + "assets/img/55.9487554e.png";